// @flow

import { css } from 'styled-components';
import { antiAlias, zIndexMap } from '../../../helpers';

export default () => css`
  position: sticky;
  top: 0;
  z-index: ${zIndexMap.stickyRow};

  ${antiAlias()}
`;
